
import { mapGetters } from 'vuex'
import BundleBreadcrumb from './bundle-common/bundle-breadcrumb.vue'
import BundleGallery from './bundle-gallery'
import BundleTitle from './bundle-common/bundle-title.vue'
import BundleProduct from './bundle-product'
import BundleSizeGuide from './bundle-size-guide'
import BundleBuybox from './bundle-buybox'
import { parseProductFromShopify } from '~/helpers/shopify/product'
export default {
  components: {
    BundleBreadcrumb,
    BundleGallery,
    BundleTitle,
    BundleProduct,
    BundleSizeGuide,
    BundleBuybox,
  },
  provide() {
    return {
      bundle: this.bundle,
      wording: this.wording,
      wordingPageProduct: this.wordingPageProduct,
    }
  },
  props: {
    bundle: {
      type: Object,
      required: true,
    },
    wording: {
      type: Object,
      required: true,
    },
    wordingPageProduct: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      products: [],
      productsFlat: [],
      selectedProducts: [],
    }
  },
  computed: {
    ...mapGetters({
      vxCurrency: 'currency/getCurrency',
    }),
    groupedProducts() {
      const productsGrouped = this.productsFlat.reduce((acc, product) => {
        acc[product.internal_type] = acc[product.internal_type] || []
        acc[product.internal_type].push(product)
        return acc
      }, {})

      const productsGroupedArr = Object.keys(productsGrouped)
        .map((key) => productsGrouped[key])
        ?.reverse()

      return productsGroupedArr
    },
  },
  watch: {
    async vxCurrency() {
      await this.fetchProducts()
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollY)
  },
  async beforeMount() {
    await this.fetchProducts()
  },
  methods: {
    variantAdd({ product, size }) {
      const removeAt = this.selectedProducts.findIndex(
        ({ product: selectedProduct }) =>
          selectedProduct.internal_type === product.internal_type
      )
      if (removeAt < 0) this.selectedProducts.push({ product, size })
    },
    variantRemove({ product }) {
      const removeAt = this.selectedProducts.findIndex(
        ({ product: selectedProduct }) =>
          selectedProduct.internal_type === product.internal_type
      )
      this.selectedProducts.splice(removeAt, 1)
    },
    async fetchProducts() {
      try {
        this.productsFlat = []
        const internal_types = this.getBundleProductIds(this.bundle.products)

        const { data } = await this.$shopify.product.getProductsByInternalType(
          internal_types,
          this.vxCurrency
        )

        const allProductsColors = data.products.edges.reduce(
          (acc, { node }) => {
            const colors = node.options.find((option) => {
              return option.name.toLowerCase() === 'color'
            })?.values
            acc[node.handle] = colors
            return acc
          },
          {}
        )

        if (data.errors) throw new Error(JSON.stringify(data.errors))
        else if (data?.products?.edges?.length > 0) {
          data.products.edges.forEach(({ node: product }) => {
            const colors = allProductsColors[product.handle]

            // TODO: refactor this (not necesary to parse for each color is it?)
            colors.forEach((color) => {
              const { result: productParsed } = parseProductFromShopify(
                product,
                this.$i18n.locale,
                color
              )
              if (productParsed) this.productsFlat.push(productParsed)
            })
          })
        }
      } catch (e) {
        this.$sentryException(e, {
          source: 'Bundle',
          level: 'fatal',
          extra: `Bundle PDP - fetchProducts() fail : ${e}`,
        })
      }
    },
    getBundleProductIds(products) {
      const internalTypes = products.map((p) => (p = p.id))
      return internalTypes
    },
    getBundleProductBaseColor(internalType) {
      return this.bundle.products
        .filter((p) => p.id === internalType)
        .map((p) => (p = p.color_code))[0]
    },
  },
}
